export const SESSION_EXISTS_MSG = 'Es existiert bereits ein offener Ordervorgang.';